import GeneralErrorView from "@/views/error/GeneralErrorView.vue"
import NotFoundView from "@/views/error/NotFoundView.vue"

export default [
    {
        name: "generalError",
        path: "/error",
        component: GeneralErrorView,
        meta: {
            public: true,
            stepper: false,
        },
    },
    {
        name: "correctErrors",
        path: "/providers/:providerKey/correctErrors",
        component: () => import("@/views/apply/CorrectErrorsView.vue"),
        props: route => ({ applicantType: route.query.applicantType }),
        meta: {
            stepper: false,
        },
    },
    {
        name: "notFound",
        path: "/404",
        component: NotFoundView,
        meta: {
            public: true,
            stepper: false,
        },
    },
    {
        name: "sessionInvalid",
        path: "/session/invalid",
        redirect: "/idle",
        meta: {
            public: true,
            stepper: false,
        },
    },
]
